<template>
  <b-tabs
    pills
    class="w-100"
  >
    <!-- Aba Reserva (conteúdo original) -->
    <b-tab
      title="Reserva"
      active
    >
      <b-row>
        <b-col
          cols="12"
          align="center"
          class="mb-2"
        >
          <h2>Reservado para {{ reserva.unidade.descricao }}</h2>
        </b-col>
        <b-col
          cols="12"
          lg="6"
          align="center"
        >
          <b-card :title="reserva.areaComum.nome">
            {{ reserva.dataHoraInicio | formatSmallDate }}
            <b-badge
              transparent
              color="primary"
            >{{
              (reserva && reserva.restricao && reserva.restricao.descricao) || ''
            }}</b-badge>
            <b-col
              cols="12"
              align="center"
              class="mt-2"
            >
              <b-button
                v-if="isMinha"
                color="danger"
                icon-pack="feather"
                class="mr-auto ml-auto"
                @click="cancelarReserva(reserva)"
              >Cancelar esta reserva</b-button>
            </b-col>
          </b-card>
        </b-col>
        <b-col
          cols="12"
          lg="6"
          align="center"
        >
          <b-card
            v-if="!isMinha && checkPermission('empresa.reserva.suplencia.enable')"
            title="Suplência"
            class="mb-base"
          >
            <b-row>
              <b-col cols="12">
                <b-form-group>
                  <v-select
                    v-model="minhaUnidade"
                    class="select-size-md"
                    label="nome"
                    :options="minhasUnidades"
                    placeholder="Selecione sua unidade..."
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-button
                  v-if="!isMinha && checkPermission('empresa.reserva.suplencia.enable')"
                  variant="primary"
                  icon-pack="feather"
                  class="mr-auto ml-auto"
                  @click="solicitarSuplencia()"
                >Solicitar Suplência</b-button>
              </b-col>
            </b-row>
          </b-card>
          <b-card
            v-if="suplentes.length > 0"
            title="Suplentes"
          >
            <b-card-text>
              <b-list-group
                v-for="suplencia in suplentes"
                :key="suplencia.id"
              >
                <b-list-group-item
                  class="d-flex justify-content-between align-items-center"
                >
                  <span>
                    {{ suplencia.unidade.descricao }}
                  </span>
                  <b-button
                    v-if="isMinhaSuplencia(suplencia.unidade.id)"
                    variant="primary"
                    size="sm"
                    @click="cancelarReserva(suplencia)"
                  >
                    <feather-icon icon="TrashIcon" />
                  </b-button>
                </b-list-group-item>
              </b-list-group>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </b-tab>

    <!-- Aba Convidados -->
    <b-tab
      v-if="isMinha || isGestor"
      title="Convidados"
    >
      <b-card>
        <b-card-text>
          <!-- Formulário para adicionar convidado -->
          <h6>Adicionar Convidado</h6>
          <b-row class="mb-2">
            <b-col
              cols="12"
              md="5"
            >
              <b-form-input
                v-model="novoConvidado.nome"
                placeholder="Nome do convidado"
              />
            </b-col>
            <b-col
              cols="12"
              md="4"
              class="mt-1 mt-md-0"
            >
              <b-form-input
                v-model="novoConvidado.documento"
                placeholder="CPF / Documento"
              />
            </b-col>
            <b-col
              cols="12"
              md="3"
              class="mt-1 mt-md-0"
            >
              <b-button
                variant="primary"
                block
                :disabled="!novoConvidado.nome || addingConvidado"
                @click="onAddConvidado"
              >
                <b-spinner
                  v-if="addingConvidado"
                  small
                />
                <feather-icon
                  v-if="!addingConvidado"
                  icon="UserPlusIcon"
                  class="mr-50"
                />
                Adicionar
              </b-button>
            </b-col>
          </b-row>

          <!-- Lista de convidados -->
          <h6 v-if="convidados.length > 0">
            Convidados ({{ convidados.length }})
          </h6>
          <b-list-group
            v-if="convidados.length > 0"
            flush
          >
            <b-list-group-item
              v-for="conv in convidados"
              :key="conv.id"
              class="d-flex justify-content-between align-items-center"
            >
              <div>
                <strong>{{ conv.nome }}</strong>
                <small
                  v-if="conv.documento"
                  class="text-muted ml-1"
                >{{ conv.documento }}</small>
                <br>
                <b-badge
                  v-if="conv.presente"
                  variant="success"
                  pill
                >
                  Presente
                  <small v-if="conv.dataHoraChegada"> - {{ conv.dataHoraChegada | formatDatetime }}</small>
                </b-badge>
                <b-badge
                  v-else
                  variant="light-secondary"
                  pill
                >Aguardando</b-badge>
              </div>
              <div>
                <b-button
                  v-if="isGestor"
                  :variant="conv.presente ? 'outline-warning' : 'outline-success'"
                  size="sm"
                  class="mr-50"
                  :disabled="!!togglingId"
                  @click="onTogglePresenca(conv)"
                >
                  <b-spinner
                    v-if="togglingId === conv.id"
                    small
                  />
                  <feather-icon
                    v-if="togglingId !== conv.id"
                    :icon="conv.presente ? 'XIcon' : 'CheckIcon'"
                  />
                  {{ conv.presente ? 'Ausente' : 'Presente' }}
                </b-button>
                <b-button
                  variant="outline-danger"
                  size="sm"
                  :disabled="!!removingId"
                  @click="onRemoveConvidado(conv)"
                >
                  <b-spinner
                    v-if="removingId === conv.id"
                    small
                  />
                  <feather-icon
                    v-if="removingId !== conv.id"
                    icon="TrashIcon"
                  />
                </b-button>
              </div>
            </b-list-group-item>
          </b-list-group>

          <b-alert
            v-if="convidados.length === 0 && !loadingConvidados"
            variant="info"
            show
            class="mt-1"
          >
            Nenhum convidado cadastrado para este evento.
          </b-alert>

          <div
            v-if="loadingConvidados"
            class="text-center mt-2"
          >
            <b-spinner />
          </div>
        </b-card-text>
      </b-card>
    </b-tab>
  </b-tabs>
</template>

<script>
import vSelect from 'vue-select'
import {
  BFormGroup,
  BFormInput,
  BListGroup,
  BListGroupItem,
  BAlert,
} from 'bootstrap-vue'
import Permissions from '../../../auth/permissions.json'

export default {
  components: {
    vSelect,
    BFormGroup,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BAlert,
  },
  data() {
    return {
      minhaUnidade: null,
      reserva: {
        descricao: null,
        unidade: { id: null, descricao: '' },
        areaComum: { nome: '' },
        restricao: { descricao: null },
      },
      suplentes: [],
      novoConvidado: { nome: '', documento: '' },
      addingConvidado: false,
      removingId: false,
      togglingId: false,
      loadingConvidados: false,
    }
  },
  computed: {
    isMinha() {
      if (!this.reserva.unidade || !this.reserva.unidade.id) return false
      const unidadeId = this.reserva.unidade.id
      return this.$store.state.minhaconta.unidades.some(
        u => u.id === unidadeId,
      )
    },
    minhasUnidades() {
      return this.$store.state.unidade.minhasUnidades
    },
    authUser() {
      return this.$store.getters['auth/authUser']()
    },
    isGestor() {
      return this.authUser
        && this.authUser.mandato
        && this.authUser.mandato.ativo
    },
    convidados() {
      return this.$store.state.reserva.convidados
    },
  },
  async beforeCreate() {
    await this.$store.dispatch('minhaconta/init')
    this.$store.dispatch('unidade/fetchMinhasUnidades')
  },
  async created() {
    if (this.$route.params.id) {
      this.reserva = this.getReserva(this.$route.params.id)
      this.suplentes = await this.listSuplencias(this.$route.params.id)
      this.fetchConvidados()
    }
  },
  methods: {
    isMinhaSuplencia(unidadeId) {
      return this.$store.state.minhaconta.unidades.some(
        u => u.id === unidadeId,
      )
    },
    checkPermission(path) {
      return Permissions[`${process.env.VUE_APP_CODE}`][path]
    },
    getReserva(reservaId) {
      return this.$store.getters['reserva/getReserva'](reservaId)
    },
    async listSuplencias(reservaId) {
      const suplentes = await this.$store.dispatch('reserva/fetchSuplencias', { eventoId: reservaId })
      return suplentes
    },
    async fetchConvidados() {
      if (!this.isMinha && !this.isGestor) return
      this.loadingConvidados = true
      try {
        await this.$store.dispatch('reserva/fetchConvidados', {
          eventoId: this.reserva.id,
        })
      } catch (err) {
        // silencioso — pode ser 403
      } finally {
        this.loadingConvidados = false
      }
    },
    async onAddConvidado() {
      if (!this.novoConvidado.nome) return
      this.addingConvidado = true
      try {
        await this.$store.dispatch('reserva/addConvidado', {
          eventoId: this.reserva.id,
          convidado: {
            nome: this.novoConvidado.nome,
            documento: this.novoConvidado.documento || null,
          },
        })
        this.novoConvidado = { nome: '', documento: '' }
        this.$toast.success('Convidado adicionado')
      } catch (err) {
        const msg = (err.response && err.response.data && err.response.data.error) || 'Erro ao adicionar convidado'
        this.$toast.error(msg)
      } finally {
        this.addingConvidado = false
      }
    },
    async onRemoveConvidado(conv) {
      this.removingId = conv.id
      try {
        await this.$store.dispatch('reserva/removeConvidado', { id: conv.id })
        this.$toast.success('Convidado removido')
      } catch (err) {
        const msg = (err.response && err.response.data && err.response.data.error) || 'Erro ao remover convidado'
        this.$toast.error(msg)
      } finally {
        this.removingId = false
      }
    },
    async onTogglePresenca(conv) {
      this.togglingId = conv.id
      try {
        await this.$store.dispatch('reserva/togglePresenca', { id: conv.id })
      } catch (err) {
        const msg = (err.response && err.response.data && err.response.data.error) || 'Erro ao registrar presença'
        this.$toast.error(msg)
      } finally {
        this.togglingId = false
      }
    },
    solicitarSuplencia() {
      this.$bvModal
        .msgBoxConfirm(
          'Sua suplencia será processada de acordo com as regras da administração. Deseja continuar?',
          {
            cancelVariant: 'outline-secondary',
          },
        )
        .then(value => {
          if (value) {
            this.$store.commit('app/TOGGLE_OVERLAY', true)
            this.$store
              .dispatch('reserva/solicitarSuplencia', {
                eventoId: this.reserva.id,
                unidadeId: this.minhaUnidade.id,
              })
              .then(() => {
                this.$loading.hide()
                this.$toast.success('Suplência confirmada com sucesso')
                this.$router.push('/reservas')
              })
              .catch(err => {
                this.$store.commit('app/TOGGLE_OVERLAY', false)
                this.$toast.error(
                  `Não foi possível solicitar no momento. ${err
                    && err.response
                    && err.response.data}`,
                )
              })
          }
        })
    },
    cancelarReserva(reserva) {
      this.$bvModal
        .msgBoxConfirm(
          'Seu cancelamento será processado se as regras do condomínio permitirem. Deseja continuar?',
          {
            cancelVariant: 'outline-secondary',
          },
        )
        .then(value => {
          if (value) {
            this.acceptAlert(reserva)
          }
        })
    },

    acceptAlert(reserva) {
      this.$store.commit('app/TOGGLE_OVERLAY', true)
      this.$store
        .dispatch('reserva/cancelarReserva', {
          evento: reserva,
        })
        .then(() => {
          this.$loading.hide()
          this.$toast.success('Sua reserva foi confirmada com sucesso')
          this.$router.push('/reservas')
        })
        .catch(err => {
          this.$store.commit('app/TOGGLE_OVERLAY', false)
          this.$toast.error(
            `Não foi possível cancelar =( ${err
              && err.response
              && err.response.data}`,
          )
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
